import { Field, ErrorMessage } from 'formik';

interface Props {
  name: string;
  type?: string;
  placeholder: string;
  label: string;
}

const LoginInput = ({ name, type = 'text', placeholder, label }: Props) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium mb-2">{label}</label>

      <Field
        name={name}
        type={type}
        placeholder={placeholder}
        className="w-full border rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-teal-500"
      />

      <ErrorMessage name={name} component="div" className="text-red-500 text-xs mt-1" />
    </div>
  );
};

export default LoginInput;
